import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LayersIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M11.55 1.1a1 1 0 0 1 .9 0l10 5a1 1 0 0 1 0 1.8l-10 5a1 1 0 0 1-.9 0l-10-5a1 1 0 0 1 0-1.8l10-5ZM4.24 7 12 10.88 19.76 7 12 3.12 4.24 7Z"
      clipRule="evenodd"
    />
    <path d="M1.1 16.55a1 1 0 0 1 1.35-.44L12 20.88l9.55-4.77a1 1 0 1 1 .9 1.78l-10 5a1 1 0 0 1-.9 0l-10-5a1 1 0 0 1-.44-1.34Z" />
    <path d="M2.45 11.1a1 1 0 1 0-.9 1.8l10 5a1 1 0 0 0 .9 0l10-5a1 1 0 1 0-.9-1.8L12 15.89l-9.55-4.77Z" />
  </Icon>
));
export default LayersIcon;
